var map = {
	"./icon-map-1.png": "6e74",
	"./icon-map-2.png": "f6d7",
	"./icon-map-3.png": "99d6",
	"./icon-map-4.png": "5e5c",
	"./icon-map-5.png": "ebf0",
	"./icon-map-6.png": "721a",
	"./icon-map-7.png": "a91f",
	"./icon-map-8.png": "06f7",
	"./icon-map-9.png": "527a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab60";